/*
 * @Descripttion: 路由鉴权
 * @FilePath: /mall-wap-vue/src/permission.js
 * @Author: 张兴业
 * @Date: 2020-09-27 14:04:08
 * @LastEditors: hl
 * @LastEditTime: 2026-04-10 13:45:51
 */
import router from "./router";
import { getToken } from "@/utils/authority";

router.beforeEach(async (to, from, next) => {
  const token = getToken();
  if (token) {
    if (to.path === "/login") {
      // 如果已经登录了，前往首页
      next({
        path: "/",
        query: {
          ...to.query,
          slug: to.query.slug || ""
        }
      });
    } else {
      if (to.query.slug) {
        return next();
      }
      if (from.query.slug) {
        const query = {
          ...to.query,
          slug: from.query.slug
        };
        router.push({
          path: to.path,
          query
        });
        return;
      } else return next();
    }
  } else {
    if (
      to.path === "/login" ||
      to.path === "/binding" ||
      to.path === "/forgot" ||
      to.path === "/forgot/reset" ||
      to.path === "/agreement/login1" ||
      to.path === "/agreement/login2" ||
      to.path === "/mine/question/list" ||
      to.path === "/mine/question/detail" ||
      to.path === "/order/explaintime" ||
      to.path === "/order/milkexplaintime" ||
      to.path === "/banner/link" ||
      to.path === "/poster/sm" ||
      to.path === "/poster/ad-machine" ||
      to.path === "/agreement"
    ) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          ...to.query,
          redirect: to.path,
          slug: to.query.slug || ""
        }
      });
    }
  }
});
